import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentResumeEntryTitle extends IsibuteDocumentComponent {};

export default IsibuteDocumentResumeEntryTitle;
